/***
 *
 *   usePlans hook
 *   fetch, format and return the price plans
 *
 **********/

import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

let planArr = [
  {
    id: 'price_1MGcZ0GdPjcvdGepIuyyh9wk',
    prodId: 'price_1MZQxbGdPjcvdGepseprG0Sz',
    name: 'Trial',
    allowed_routes: ['all'],
  },
  {
    id: 'price_1SjXi3GWO250PWbSNIKE8ivY',
    prodId: 'price_1NmacEGdPjcvdGepmmuHKhFx',
    name: 'Starter',
    allowed_routes: [
      '/dashboard',
      '/outreach/sequences',
      '/outreach/inbox-placement-test',
      '/outreach/reports',
      '/outreach/templates',
      '/outreach/outbox',
      '/outreach/lists',
      '/outreach/email-senders',
      '/outreach/settings',
      '/leads',
      '/leads/people',
      '/leads/companies',
      '/leads/lists',
      '/import-list',
      '/account/users',
    ],
  },
  {
    id: 'price_1SjXiNGWO250PWbSgYG5sbpk',
    prodId: 'price_1NmacEGdPjcvdGep2Es38a71',
    name: 'Starter Yearly',
    allowed_routes: [
      '/dashboard',
      '/outreach/sequences',
      '/outreach/inbox-placement-test',
      '/outreach/reports',
      '/outreach/templates',
      '/outreach/outbox',
      '/outreach/lists',
      '/outreach/email-senders',
      '/outreach/settings',
      '/leads',
      '/leads/people',
      '/leads/companies',
      '/leads/lists',
      '/import-list',
      '/account/users',
    ],
  },
  {
    id: 'price_1SjXjxGWO250PWbSZVj312Z5',
    prodId: 'price_1NmacNGdPjcvdGepsKomGWo4',
    name: 'Growth',
    allowed_routes: [
      '/dashboard',
      '/outreach/sequences',
      '/outreach/inbox-placement-test',
      '/outreach/reports',
      '/outreach/templates',
      '/outreach/outbox',
      '/outreach/lists',
      '/outreach/email-senders',
      '/outreach/settings',
      '/leads',
      '/leads/people',
      '/leads/companies',
      '/leads/lists',
      '/import-list',
      '/blink-gpt-pro',
      '/warmup-pro',
      '/meet',
      '/meet/my-calender',
      '/meet/settings',
      '/account/users',
      '/account/integration'
    ],
  },
  {
    id: 'price_1SjXjxGWO250PWbSm4OR9c17',
    prodId: 'price_1NmacNGdPjcvdGepXIPMMVgF',
    name: 'Growth Yearly',
    allowed_routes: [
      '/dashboard',
      '/outreach/sequences',
      '/outreach/inbox-placement-test',
      '/outreach/reports',
      '/outreach/templates',
      '/outreach/outbox',
      '/outreach/lists',
      '/outreach/email-senders',
      '/outreach/settings',
      '/leads',
      '/leads/people',
      '/leads/companies',
      '/leads/lists',
      '/import-list',
      '/blink-gpt-pro',
      '/warmup-pro',
      '/meet',
      '/meet/my-calender',
      '/meet/settings',
      '/account/users',
      '/account/integration'
    ],
  },
  {
    id: 'price_1SjXlGGWO250PWbSaYYV1In2',
    prodId: 'price_1NmacTGdPjcvdGep92G9GQKO',
    name: 'Business',
    allowed_routes: [
      '/dashboard',
      '/outreach/sequences',
      '/outreach/inbox-placement-test',
      '/outreach/tasks',
      '/outreach/reports',
      '/outreach/templates',
      '/outreach/outbox',
      '/outreach/lists',
      '/outreach/email-senders',
      '/outreach/settings',
      '/leads',
      '/leads/people',
      '/leads/companies',
      '/leads/lists',
      '/import-list',
      '/blink-gpt-pro',
      '/warmup-pro',
      '/meet',
      '/meet/my-calender',
      '/meet/settings',
      '/account/users',
      '/account/integration'
    ],
  },
  {
    id: 'price_1SjXlGGWO250PWbSdpwja5oT',
    prodId: 'price_1NmacTGdPjcvdGepI1laNWPb',
    name: 'Business Yearly',
    allowed_routes: [
      '/dashboard',
      '/outreach/sequences',
      '/outreach/inbox-placement-test',
      '/outreach/tasks',
      '/outreach/reports',
      '/outreach/templates',
      '/outreach/lists',
      '/outreach/outbox',
      '/outreach/email-senders',
      '/outreach/settings',
      '/leads',
      '/leads/people',
      '/leads/companies',
      '/leads/lists',
      '/import-list',
      '/blink-gpt-pro',
      '/warmup-pro',
      '/meet',
      '/meet/my-calender',
      '/meet/settings',
      '/account/users',
      '/account/integration'
    ],
  },
  {
    id: 'price_1SjXmRGWO250PWbSoMNphCBc',
    prodId: 'price_1Ph1psGdPjcvdGepRNZruWNA',
    name: 'Agency Starter',
    allowed_routes: [
      '/dashboard',
      '/outreach/sequences',
      '/outreach/inbox-placement-test',
      '/outreach/reports',
      '/outreach/templates',
      '/outreach/lists',
      '/outreach/outbox',
      '/outreach/email-senders',
      '/outreach/settings',
      '/leads',
      '/leads/people',
      '/leads/companies',
      '/leads/lists',
      '/import-list',
      '/blink-gpt-pro',
      '/warmup-pro',
      '/account/users',
      '/account/whitelabel'
    ],
  },
  {
    id: 'price_1SjXmRGWO250PWbSnfVEB8d9',
    prodId: 'price_1Ph1psGdPjcvdGepnbYjAxPc',
    name: 'Agency Starter Yearly',
    allowed_routes: [
      '/dashboard',
      '/outreach/sequences',
      '/outreach/inbox-placement-test',
      '/outreach/reports',
      '/outreach/templates',
      '/outreach/lists',
      '/outreach/outbox',
      '/outreach/email-senders',
      '/outreach/settings',
      '/leads',
      '/leads/people',
      '/leads/companies',
      '/leads/lists',
      '/import-list',
      '/blink-gpt-pro',
      '/warmup-pro',
      '/account/users',
      '/account/whitelabel'
    ],
  },
  {
    id: 'price_1SjXnVGWO250PWbSv6zvfelo',
    prodId: 'price_1Ph1pwGdPjcvdGepxUk00D9W',
    name: 'Agency Growth',
    allowed_routes: [
      '/dashboard',
      '/outreach/sequences',
      '/outreach/inbox-placement-test',
      '/outreach/reports',
      '/outreach/templates',
      '/outreach/lists',
      '/outreach/outbox',
      '/outreach/email-senders',
      '/outreach/settings',
      '/leads',
      '/leads/people',
      '/leads/companies',
      '/leads/lists',
      '/import-list',
      '/blink-gpt-pro',
      '/warmup-pro',
      '/meet',
      '/meet/my-calender',
      '/meet/settings',
      '/account/users',
      '/account/integration',
      '/account/whitelabel'
    ],
  },
  {
    id: 'price_1SjXnVGWO250PWbSo1bvkbsk',
    prodId: 'price_1Ph1pwGdPjcvdGepYS6hYU2e',
    name: 'Agency Growth Yearly',
    allowed_routes: [
      '/dashboard',
      '/outreach/sequences',
      '/outreach/inbox-placement-test',
      '/outreach/reports',
      '/outreach/templates',
      '/outreach/lists',
      '/outreach/outbox',
      '/outreach/email-senders',
      '/outreach/settings',
      '/leads',
      '/leads/people',
      '/leads/companies',
      '/leads/lists',
      '/import-list',
      '/blink-gpt-pro',
      '/warmup-pro',
      '/meet',
      '/meet/my-calender',
      '/meet/settings',
      '/account/users',
      '/account/integration',
      '/account/whitelabel'
    ],
  },
  {
    id: 'price_1SjXoQGWO250PWbSugIxVKYV',
    prodId: 'price_1Ph1pzGdPjcvdGepT5TslN8s',
    name: 'Agency Business',
    allowed_routes: [
      '/dashboard',
      '/outreach/sequences',
      '/outreach/inbox-placement-test',
      '/outreach/tasks',
      '/outreach/reports',
      '/outreach/templates',
      '/outreach/lists',
      '/outreach/outbox',
      '/outreach/email-senders',
      '/outreach/settings',
      '/leads',
      '/leads/people',
      '/leads/companies',
      '/leads/lists',
      '/import-list',
      '/blink-gpt-pro',
      '/warmup-pro',
      '/meet',
      '/meet/my-calender',
      '/meet/settings',
      '/account/users',
      '/account/integration',
      '/account/whitelabel'
    ],
  },
  {
    id: 'price_1SjXoQGWO250PWbSehZXVcAh',
    prodId: 'price_1Ph1pzGdPjcvdGep8Cer6g7m',
    name: 'Agency Business Yearly',
    allowed_routes: [
      '/dashboard',
      '/outreach/sequences',
      '/outreach/inbox-placement-test',
      '/outreach/tasks',
      '/outreach/reports',
      '/outreach/templates',
      '/outreach/lists',
      '/outreach/outbox',
      '/outreach/email-senders',
      '/outreach/settings',
      '/leads',
      '/leads/people',
      '/leads/companies',
      '/leads/lists',
      '/import-list',
      '/blink-gpt-pro',
      '/warmup-pro',
      '/meet',
      '/meet/my-calender',
      '/meet/settings',
      '/account/users',
      '/account/integration',
      '/account/whitelabel'
    ],
  },
];

export function useRouteCheck(route, plans, subscription, expired) {
  const [state, setState] = useState(false);
  let navigator = useNavigate();

  useEffect(() => {
    // console.log("TEST UP ",route, plans, subscription, expired)
    if (subscription === 'ltd') return setState(true);
    if (subscription === 'trialing') return setState(true);
    if (expired) return navigator('/account/billing?tab=invoice');
    if (plans) {
      let planList = plans.split(',');
      for (let i = 0; i < planList.length; i++) {
        let existPlan = planArr.find((p) => {
          if (p.id === planList[i] || p.prodId === planList[i]) return p;
        });
        if (existPlan) {
          if (route === '/') return setState(true);
          else if (existPlan.allowed_routes.find((r) => route.includes(r)))
            return setState(true);
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [plans]);

  return state;
}
